import { atom } from 'jotai'
import { atomWithReset } from 'jotai/utils'

import { AppointmentType, SourceService } from '../../__generated__/api'

export type AppointmentId = number | string

export const selectedAppointmentIdAtom = atom<AppointmentId | undefined>(undefined)

export const selectedAppointmentTypeAtom = atom<AppointmentType | undefined>(undefined)

export const authenticationModalOpenAtom = atom<boolean>(false)

export const selectedAppointmentLengthAtom = atom<number | 'default'>('default')

export const generalErrorMessageAtom = atom<string | undefined>(undefined)

export const selectedAppointmentNodeIdAtom = atom<string | undefined>(undefined)

export const selectedAppointmentNodeConnectionIdAtom = atom<string | undefined>(undefined)

export const selectedAppointmentServiceIdAtom = atom<number | undefined>(undefined)

export const isFromAppAtom = atom<boolean>(false)

export const isFromRelayAppAtom = atom<boolean>(false)

export const isFromOMAtom = atom<boolean>(false)

export const sourceServiceAtom = atom<SourceService | undefined>(undefined)

export const selectedInsuranceAtom = atomWithReset<number | null>(null)

export const selectedInsurancePayerAtom = atomWithReset<string | null>(null)

export const isRedirectedFromInsuranceProviderAtom = atom<boolean>(false)

export const scheduledMaintenanceMessageAtom = atom<string | undefined>(undefined)

export const isOHCAtom = atom<boolean>(false)

export const marketingCampaignCodeAtom = atom<string | undefined>(undefined)
